import { InlineVideo } from '~/components/inline-video';
import { HomepageSlide } from '../common';
import { $HomepageMaterial } from 'shared/atoms/homepage-material';
import { useAtomValue } from 'jotai';
import { FC } from 'react';
import { SwiperSlide } from 'swiper/react';
import Phone from './assets/phone.svg?inline';
import QRCodeBG from '../../assets/qrcode-bg.svg?inline';
import PHONE_GRADIENT from './assets/phone-gradient.svg?inline';
import { useSloganLandscape } from './assets/slogan-landscape';
import { useQRCode } from '~/assets/qr-code';
import { useDownloadPrompt } from '../../assets/download-prompt';
import { useSloganPortrait } from './assets/slogan-portrait';
import { useBtnPortrait } from './assets/btn-portrait';
import { usePlatformDownloadButton } from '~/assets/download-platform';
import { EPageModule } from '~/utils/page-module';
import { useViewObserver } from '@lemon8/web-app-shared/util';
import { EClickPosition } from '~/utils/click-position';
import { activeToFeed } from '~/utils/active';
import { $FallbackGpToApk } from '@lemon8/web-app-shared/atom';

import './style.scss';

const PAGE_MODULE = EPageModule.OVERALL_INTRO;

export const MainSlide: FC = () => {
  const { videoUrl, posterUrl } = useAtomValue($HomepageMaterial);
  const fallbackGpToApkConfig = useAtomValue($FallbackGpToApk);
  const SLOGAN_LANDSCAPE = useSloganLandscape();
  const SLOGAN_PORTRAIT = useSloganPortrait();
  const BTN_PORTRAIT = useBtnPortrait();
  const QRCode = useQRCode();
  const DownloadPrompt = useDownloadPrompt();
  const googlePlayDownloader = usePlatformDownloadButton(fallbackGpToApkConfig.enable ? 'APK' : 'Android');
  const appleStoreDownloader = usePlatformDownloadButton('iOS');

  const mobileDownloadRef = useViewObserver<HTMLImageElement>({
    onView: () => {
      window.Tea('wap_cta_show', {
        current_page_module: PAGE_MODULE,
        current_position: EClickPosition.BOTTOM_BUTTON,
      });
    },
  });

  const handleMobileDownloadClick = (): void => {
    window.Tea('wap_click', {
      current_page_module: PAGE_MODULE,
      current_position: EClickPosition.BOTTOM_BUTTON,
      is_cta: 1,
    });
    activeToFeed({
      currentPosition: EClickPosition.BOTTOM_BUTTON,
    });
  };

  const handleAndroidDownloadClick = (): void => {
    window.Tea('wap_click', {
      current_page_module: PAGE_MODULE,
      current_position: EClickPosition.DOWNLOAD_GOOGLE_PLAY,
      is_cta: 0,
    });
    activeToFeed({
      currentPosition: EClickPosition.DOWNLOAD_GOOGLE_PLAY,
    });
  };

  const handleIosDownloadClick = (): void => {
    window.Tea('wap_click', {
      current_page_module: PAGE_MODULE,
      current_position: EClickPosition.DOWNLOAD_APPSTORE,
      is_cta: 0,
    });
    activeToFeed({
      currentPosition: EClickPosition.DOWNLOAD_APPSTORE,
    });
  };

  return (
    <HomepageSlide className="homepage-slide-main" pageModule={PAGE_MODULE}>
      <InlineVideo className="phone-content" src={videoUrl} poster={posterUrl} />
      <img src={Phone} className="phone-wrapper" />
      <img className="phone-gradient-portrait" src={PHONE_GRADIENT} />

      <img className="slogan-landscape" src={SLOGAN_LANDSCAPE} />
      <img className="slogan-portrait" src={SLOGAN_PORTRAIT} />

      <img className="qrcode-wrapper" src={QRCodeBG} />
      <img className="qrcode" src={QRCode.src} />
      <img className="download-prompt" src={DownloadPrompt} />
      <img className="app-store" {...appleStoreDownloader} onClick={handleIosDownloadClick} />
      <img className="google-play" {...googlePlayDownloader} onClick={handleAndroidDownloadClick} />

      <img className="btn-portrait" src={BTN_PORTRAIT} ref={mobileDownloadRef} onClick={handleMobileDownloadClick} />
    </HomepageSlide>
  );
};

MainSlide.displayName = SwiperSlide.displayName;
